import React from "react"

import getMessageBaseClasses from "../../utils/MessageUtils"

export default function LoadingIndicatorMessage(): JSX.Element {
    // we want this to look like real text
    // thus we won't use the font for this
    const content = "..."

    const classes = `${getMessageBaseClasses({
        shouldAddNoteTheme: true,
        shouldAddCloudBackground: false,
    })} is-loading`

    return (
        <div className={classes} data-ft-component="loading-indicator">
            {content}
        </div>
    )
}
